import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';

/**
 * Parça seçim bölümü - Yeni iade talebi için parça dropdown'u
 */
const PartSelectionSection = ({ 
    formData, 
    partOptions, 
    errors, 
    submitted, 
    loadingParts, 
    onPartChange,
    onFilterChange,
    filterValue,
    th 
}) => {
    const itemTemplate = (opt) => (
        <div>
            <strong>{opt.code}</strong> – {opt.name}
        </div>
    );

    // Loading durumunda gösterilecek template
    const loadingTemplate = () => (
        <div className="flex align-items-center justify-content-center p-3">
            <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" />
            <span className="ml-2">{th("dealerPartsReturnProcess.returnRequest.searching")}</span>
        </div>
    );

    // Custom filter template - Dropdown'ın internal filter'ı yerine kendi kontrollü input'umuz
    const filterTemplate = () => (
        <div className="p-dropdown-filter-container">
            <InputText
                value={filterValue}
                onChange={(e) => onFilterChange(e.target.value)}
                className="p-dropdown-filter w-full"
                placeholder={th("dealerPartsReturnProcess.returnRequest.partSearchPlaceholder")}
                autoFocus
            />
            <span className="p-dropdown-filter-icon pi pi-search" />
        </div>
    );

    return (
        <div className="col-12">
            <div className="field">
                <label htmlFor="partSelect">{th('packageDefinitions.partName')} *</label>
                <Dropdown
                    id="partSelect"
                    value={formData.partCode}
                    onChange={(e) => onPartChange(e.value)}
                    options={partOptions}
                    optionLabel="label"
                    optionValue="code"
                    filter
                    filterTemplate={filterTemplate}
                    showClear
                    placeholder=""
                    itemTemplate={itemTemplate}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    className={submitted && errors.part ? 'p-invalid w-full' : 'w-full'}
                    loading={loadingParts}
                emptyFilterMessage={loadingParts ? loadingTemplate() : th("dealerPartsReturnProcess.returnRequest.noResults")}
                emptyMessage={loadingParts ? loadingTemplate() : th("common.noRecords")}
                />
                {submitted && errors.part && <small className="p-error">{errors.part}</small>}
            </div>
        </div>
    );
};

export default PartSelectionSection;

